<template>
<div class="chapter">
<div class="inner_page">
<a id="page_11"></a>
<h2 class="part"><span class="bold">PART 1</span></h2>
<h2 class="part1"><span class="bold">INNOVATION AND CONFRONTATION</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Part01.vue?e2ed1828